module.exports = __webpack_public_path__ + "static/img/man-3803551_960_720.bcbb277.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/man-3803551_960_720.webp
// module id = rnYe
// module chunks = 0